import React from 'react';

import { FormControl, Select, SelectItemProps } from '@rbilabs/universal-components';
import { FieldProps } from 'formik';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { spacing } from 'styles/constants';

type Props = FieldProps<string, { [key: string]: string }> & {
  options: SelectItemProps[];
  label: string;
  hintMessage?: string;
};

export const FormikSelect: React.FC<React.PropsWithChildren<Props>> = ({
  field,
  form,
  ...props
}) => {
  const { options, label, hintMessage } = props;
  const errorMessage =
    form.touched[field.name] && form.errors[field.name] ? form.errors[field.name] : undefined;

  useLogUserErrorMessage({
    message: errorMessage,
    severity: LogUserErrorSeverity.Unknown,
    context: {
      fieldName: field?.name,
      label,
    },
  });

  return (
    <Box style={styles.container}>
      <FormControl>
        {label && <FormControl.Label>{label}</FormControl.Label>}
        <Select {...field} {...props}>
          {options.map((option, optionKey) => (
            <Select.Item key={optionKey} value={option.value} label={option.label} />
          ))}
        </Select>
        {hintMessage && !errorMessage && (
          <FormControl.HelperText margin="0" padding="0">
            {hintMessage}
          </FormControl.HelperText>
        )}
        {errorMessage && <FormControl.ErrorMessage>{errorMessage}</FormControl.ErrorMessage>}
      </FormControl>
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    margin: spacing.$2,
  },
});
